import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./ContactForm.module.css";
import { submitContactForm } from "../utils/contactApi";

function ContactForm({ isOpen, onClose }) {
  const modalRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(isOpen);

  const handleClose = useCallback((e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  }, [onClose]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape") {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    let timeoutId;

    if (isOpen) {
      setShouldRender(true);
    } else {
      timeoutId = window.setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClose);
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.removeEventListener("mousedown", handleClose);
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = ""; // Re-enable scrolling
    }
    return () => {
      document.removeEventListener("mousedown", handleClose);
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = ""; // Clean up on unmount
    };
  }, [handleClose, handleKeyDown, isOpen]);

  if (!shouldRender) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    try {
      const result = await submitContactForm(formData);
      alert(result.message);
      form.reset();
      onClose();
    } catch (error) {
      console.error("Fehler beim Senden der Nachricht:", error);
      alert("Fehler beim Senden der Nachricht: " + error.message);
    }
  };

  return (
    <div className={`${styles.overlay} ${isOpen ? styles.open : ""}`}>
      <div className={styles.modal} ref={modalRef}>
        <button className={styles.closeButton} onClick={onClose} type="button">
          &times;
        </button>
        <div className={styles.modalContent}>
          <div className={styles.formContainer}>
            <h2>Kontaktieren Sie uns!</h2>
            <form className={styles.form} onSubmit={handleSubmit} autoComplete="on">
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="firstName">Vorname*</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    autoComplete="given-name"
                    required
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="lastName">Nachname*</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    autoComplete="family-name"
                    required
                  />
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="companyName">Unternehmensname</label>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    autoComplete="organization"
                  />
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="position">Position</label>
                  <input
                    type="text"
                    id="position"
                    name="position"
                    autoComplete="organization-title"
                  />
                </div>
              </div>
              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label htmlFor="email">E-Mail*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    autoComplete="email"
                    required
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="phoneNumber">Telefonnummer</label>
                  <input
                    type="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    autoComplete="tel"
                  />
                </div>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="topic">
                  Bei welchem Thema können wir Sie unterstützen?*
                </label>
                <input
                  type="text"
                  id="topic"
                  name="topic"
                  autoComplete="off"
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="message">Nachricht</label>
                <textarea
                  id="message"
                  name="message"
                  autoComplete="off"
                  rows="5"
                />
              </div>
              <button type="submit" className={styles.submitButton}>
                Senden
              </button>
            </form>
          </div>
          <div className={styles.infoContainer}>
            <h3>Hauptstandort</h3>
            <p>datacook</p>
            <p>Alleenstraße 15</p>
            <p>74372 Sersheim</p>
            <a href="mailto:info@datacook.de">E-Mail senden</a>
            <p>
              Tel: <a href="tel:+491794157744">+49 179 415 7744</a>
            </p>
            {/* <div className={styles.socialLinks}>
              <a href="#">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-youtube"></i>
              </a>
            </div> */}
            <p className={styles.legalText}>
              Bei Datacook nutzen wir Ihre Kontaktdaten, um Sie über unsere
              neuesten Produkte und Dienstleistungen zu informieren. Keine
              Sorge, Sie können sich jederzeit von unseren Updates abmelden.
              Mehr über unsere Datenschutzrichtlinien und unser Engagement für
              Ihre Privatsphäre erfahren Sie in unseren Datenschutzbestimmungen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
